var map = {
	"./arrow.svg": "b94f",
	"./arrow2.svg": "8a7d",
	"./article.svg": "b6220",
	"./back.svg": "ccfe",
	"./briefcase.svg": "89bd",
	"./bubble.svg": "1b71",
	"./bulleted-list.svg": "085c",
	"./calendar-plus.svg": "119f",
	"./calendar.svg": "1a34",
	"./camera.svg": "0b86",
	"./cancel-circle.svg": "1b64",
	"./chat-bubble.svg": "b80b",
	"./chat-edit.svg": "31bd",
	"./chat.svg": "5f66",
	"./check.svg": "f222",
	"./clock.svg": "e0f8",
	"./comment.svg": "cf89",
	"./conference.svg": "bcaa",
	"./contact-details.svg": "b3e4",
	"./delete.svg": "d739",
	"./diploma.svg": "0e95",
	"./direction.svg": "58e7",
	"./eaaci-activity.svg": "4f5c",
	"./edit.svg": "6582c",
	"./edit2.svg": "8b3e",
	"./evaluation.svg": "8473",
	"./expand.svg": "78cf",
	"./external-link.svg": "6a16",
	"./facebook.svg": "aaa3",
	"./filter.svg": "5ee4",
	"./folder.svg": "abfe",
	"./full_screen.svg": "5f10",
	"./game.svg": "0e52",
	"./giftcard.svg": "23ce",
	"./globe.svg": "83ab5",
	"./group.svg": "45f3",
	"./handshake.svg": "4541",
	"./heart-filled.svg": "a143",
	"./heart.svg": "fbe8",
	"./hint.svg": "1dd7",
	"./image.svg": "19e7",
	"./info.svg": "07e6",
	"./information.svg": "d7f9",
	"./instagram.svg": "54e6",
	"./left.svg": "c75b",
	"./linkedin.svg": "953d",
	"./live.svg": "2f47",
	"./lock.svg": "3c1a",
	"./login.svg": "ebec",
	"./logo.svg": "9b19",
	"./logout.svg": "309a",
	"./logow.svg": "e103",
	"./mail.svg": "1752",
	"./minus.svg": "e9b2",
	"./mobile.svg": "8b45",
	"./navigate.svg": "f572",
	"./ok-circle.svg": "24f1",
	"./ok.svg": "76a5",
	"./online-support.svg": "d846",
	"./pdf.svg": "0db0",
	"./pin.svg": "9b70",
	"./plus.svg": "8a37",
	"./poll.svg": "de3c",
	"./profile_bg.svg": "4124",
	"./quick.svg": "5007",
	"./rating.svg": "4489",
	"./refresh.svg": "b7d8",
	"./register.svg": "933b",
	"./retro_tv.svg": "44b4",
	"./ring.svg": "42e2",
	"./search.svg": "51f2",
	"./send.svg": "ad0d",
	"./sort-alpha.svg": "ca8b",
	"./speaker.svg": "612c",
	"./star.svg": "42a8",
	"./star_empty.svg": "3d52",
	"./star_filled.svg": "67ad",
	"./support.svg": "2621",
	"./test.svg": "c2db",
	"./time-congress.svg": "8492",
	"./time-local.svg": "0d2a",
	"./timeline.svg": "f823",
	"./timer.svg": "6661",
	"./timetable.svg": "bad4",
	"./topic.svg": "3206",
	"./translation.svg": "f579",
	"./twitter.svg": "a3df",
	"./user-account.svg": "7c65",
	"./user-add.svg": "0f31",
	"./user-check.svg": "532e",
	"./user.svg": "0f62",
	"./user_female.svg": "df35",
	"./user_generic.svg": "6144",
	"./user_male.svg": "27a2",
	"./video-call.svg": "8fe4",
	"./video.svg": "8e0f",
	"./vimeo.svg": "6696",
	"./website.svg": "9365",
	"./wreath-w.svg": "5b8b",
	"./wreath.svg": "0a40",
	"./youtube-2.svg": "44cf",
	"./youtube.svg": "73dd",
	"./zoom.svg": "34c3"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "31e8";